import uuid from "../../../library/uuid.js";
import ObjectHandle from "../ObjectHandle.js";

// import global from "../../global.js";
// const log = global.log.getLogger("f_mtac.scene.drivers.voronoipole");

const VoronoiPole = function(group, color, intensity) {
    this.data = {
        id: `local-${uuid()}`,
        color: color,
        class: ["node", "voronoi-pole", "object", "movable", "removable"],
        storage: "object"
    };
    this.group = group;
    this.handle = null;
    this.node = null;
    this.intensity = intensity;
    this.position = {
        x: 0,
        y: 0
    };
};
VoronoiPole.prototype.draw = function(x, y) {
    this.group.select(`#${this.data.id}`).remove();
    this.handle = this.group.append("g").attr("class", "handle").attr("id", this.data.id);
    this.node = this.handle.append("g").attr("class", this.data.class.join(" "));
    this.node.attr("data-type", "object");
    this.node.attr("data-subtype", "voronoi_pole");
    this.node.attr("data-voronoi-intensity", this.intensity);
    this.position.x = x;
    this.position.y = y;
    this.node.attr("transform", `translate(${this.position.x},${this.position.y})`);
};
VoronoiPole.prototype.update = function(x, y) {
    this.position.x = x;
    this.position.y = y;
    this.node.attr("transform", `translate(${this.position.x},${this.position.y})`);
};
VoronoiPole.prototype.end = function() {
    let object_handle = ObjectHandle({x: 0, y: 0, color: this.data.color});
    this.node.append(() => object_handle.node());
    return Promise.resolve();
};
VoronoiPole.prototype.is_empty = function() {
    return false;
};
VoronoiPole.prototype.detach = function() {
    this.handle = null;
    this.node = null;
};
VoronoiPole.prototype.export = function() {
    return this.handle;
};
export default VoronoiPole;
